import React from 'react'
import PropTypes from 'prop-types'
import { mediaQueries } from '@blazar-plugins/device'

import { TextCallout2 } from 'blocket-ui'
import styled from 'styled-components'

import { numberGroup } from 'utils/format'

const StyledCaption = styled(TextCallout2)`
  color: #696766;
  @media ${mediaQueries.large} {
    padding-top: 2px;
    display: inline-block;
  }
`

export const _ListResultCountLabel = ({ results }) => (
  <StyledCaption data-cy="search-result-count">
    {numberGroup(results)} {results === 1 ? 'annons' : 'annonser'}
  </StyledCaption>
)

_ListResultCountLabel.propTypes = {
  results: PropTypes.number.isRequired,
}

export default _ListResultCountLabel
